<template>
	<div v-if="visible" class="alert-confirm" @click.self="resetValues">
		<div class="alert-confirm__box max-width">
			<h2 class="heading__h2">
				{{ labels.text }}
			</h2>
			<div class="alert-confirm__row">
				<button class="button__delete" @click="confirmAlert">
					{{ labels.confirm ? labels.confirm : $t('buttons.delete') }}
				</button>
				<button class="button__primary" @click="resetValues">
					{{ labels.cancel ? labels.cancel : $t('buttons.cancel') }}
				</button>
			</div>
			<div v-if="isLoading" class="alert-confirm__loader">
				<div class="loader" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		visible: ({ $store }) => $store.getters['alert/confirm'],
		labels: ({ $store }) => $store.getters['alert/labelsConfirm'],
		action: ({ $store }) => $store.getters['alert/actionConfirm']
	},
	data: () => ({ isLoading: false }),
	methods: {
		async confirmAlert() {
			if (!this.isLoading) {
				this.isLoading = true
				if (this.action.payload) {
					if (this.action.async) {
						await this.$store.dispatch(this.action.name, this.action.payload)
					} else {
						this.$store.dispatch(this.action.name, this.action.payload)
					}
				} else {
					this.$store.dispatch(this.action)
				}
				this.isLoading = false
				this.$alertBox({
					labels: {
						text: this.labels.success
					},
					type: 'warning'
				})
				const redirect = this.action.redirect ? this.action.redirect : false
				this.resetValues()
				if (redirect) {
					this.changeLocation(redirect)
				}
			}
		},
		resetValues() {
			if (!this.isLoading) {
				this.$store.dispatch('alert/resetConfirm')
			}
		},
		changeLocation(redirect) {
			if (!this.isLoading) {
				this.$router.push(redirect)
			}
		}
	}
}
</script>
